export enum Intents {
  ADD_SWIMLANE = "add-swimlane",
  ADD_STEP = "add-step",
  ADD_FIELD = "add-field",
  ADD_RULE = "add-rule",
  ADD_RULES = "add-rules",

  DELETE_SWIMLANE = "delete-swimlane",
  DELETE_STEP = "delete-step",
  DELETE_FIELD = "delete-field",
  DELETE_RULES = "delete-rules",

  UPDATE_SWIMLANE = "update-swimlane",
  UPDATE_STEP = "update-step",
  UPDATE_FIELD = "update-field",
  UPDATE_RULE = "update-rule",

  ADD_EVENT_RULE = "add-event-rule",
  DELETE_EVENT_RULE = "delete-event-rule",
  UPDATE_EVENT_RULE = "update-event-rule",

  ADD_STATE_RULE = "add-state-rule",
  DELETE_STATE_RULE = "delete-state-rule",
  UPDATE_STATE_RULE = "update-state-rule",

  UPDATE_ON_CREATE_WORKFLOW = "update-on-create-workflow", // TODO: @abir Phase 2

  DUPLICATE_SWIMLANE = "duplicate-swimlane",
  DUPLICATE_STEP = "duplicate-step",
  DUPLICATE_FIELD = "duplicate-field",

  REORDER_FIELD = "reorder-field",
  REORDER_STEP = "reorder-step",
  REORDER_SWIMLANE = "reorder-swimlane",

  MIGRATE_PROCESS = "migrate-process",
  UPDATE_PROCESS = "update-process",
  IMPORT_JSON = "import-json",

  IMPORT_MODULE_TEMPLATE = "import-module-template",
  IMPORT_SWIMLANE_TEMPLATE = "import-swimlane-template",
  IMPORT_SWIMLANE_TEMPLATE_IN_EXISTING_SWIMLANE = "import-swimlane-template-in-existing-swimlane",
  IMPORT_STEP_TEMPLATE = "import-step-template",
  IMPORT_STEP_TEMPLATE_IN_EXISTING_STEP = "import-step-template-in-existing-step",
  IMPORT_FIELD_TEMPLATE = "import-field-template",
  IMPORT_MULTI_PROCESS_TEMPLATE = "import-multi-process-template",

  IMPORT_FIELDS_CSV_IN_STEP = "import-fields-csv-in-step",

  IMPORT_BRD_SWIMLANE = "import-brd-swimlane",
  DESIGN_AI_PROMPT = "design-ai-prompt",

  UNDO = "undo",
  REDO = "redo",
  REVERT_TO_OLDER_COMMIT = "revert-to-older-commit",

  SAVE_ID_UPDATE = "SAVE_ID_UPDATE",

  UPDATE_APP_SETTINGS = "update-app-settings",

  ADD_DATA_OBJECT = "add-data-object",
  UPDATE_DATA_OBJECT = "update-data-object",
  DELETE_DATA_OBJECT = "delete-data-object",
  UPDATE_DATA_OBJECTS = "update-data-objects"
}

export enum AIIntents {
  CREATE_PROCESS = "create-process",
  CREATE_SWIMLANE = "create-swimlane",
  CREATE_STEP = "create-step",
  CREATE_FIELD = "create-field",
  CREATE_EVENT_RULE = "create-event-rule",
  CREATE_EVENT_RULE_RULE = "create-event-rule-rule",
  CREATE_EVENT_RULE_EVENT = "create-event-rule-event",
  CREATE_APP_SETTINGS = "create-app-settings",
  CREATE_DATA_OBJECT = "create-data-object",

  UPDATE_PROCESS = "update-process",
  UPDATE_SWIMLANE = "update-swimlane",
  UPDATE_STEP = "update-step",
  UPDATE_FIELD = "update-field",
  UPDATE_EVENT_RULE = "update-event-rule",
  UPDATE_EVENT_RULE_RULE = "update-event-rule-rule",
  UPDATE_EVENT_RULE_EVENT = "update-event-rule-event",
  UPDATE_APP_SETTINGS = "update-app-settings",
  UPDATE_DATA_OBJECT = "update-data-object",

  DELETE_PROCESS = "delete-process",
  DELETE_SWIMLANE = "delete-swimlane",
  DELETE_STEP = "delete-step",
  DELETE_FIELD = "delete-field",
  DELETE_EVENT_RULE = "delete-event-rule",
  DELETE_EVENT_RULE_RULE = "delete-event-rule-rule",
  DELETE_EVENT_RULE_EVENT = "delete-event-rule-event",
  DELETE_APP_SETTINGS = "delete-app-settings",
  DELETE_DATA_OBJECT = "delete-data-object"
}
